import { useQuery } from '@tanstack/react-query';

import { INCIDENTS_MOCK, MONITORING_SUMMARY_MOCK } from './monitoring.mock';

import type { IncidentListResponse, MonitoringSummary } from './monitoring.types';

/**
 * Query Key Factory for the Monitoring domain.
 */
export const monitoringQueryKeys = {
  all: ['monitoring'] as const,
  summary: () => [...monitoringQueryKeys.all, 'summary'] as const,
  incidents: () => [...monitoringQueryKeys.all, 'incidents'] as const,
};

/**
 * Returns the live operational health summary.
 *
 * TODO: swap the mock resolution for `monitoringService.getSummary()` once
 * the rewrite exposes `GET /admin/monitoring/summary`.
 */
export const useGetMonitoringSummary = () => {
  return useQuery({
    queryKey: monitoringQueryKeys.summary(),
    queryFn: async (): Promise<MonitoringSummary> => {
      return MONITORING_SUMMARY_MOCK;
    },
  });
};

/**
 * Returns the operational incidents feed.
 *
 * TODO: swap the mock resolution for `monitoringService.listIncidents()` once
 * the rewrite exposes `GET /admin/monitoring/incidents`.
 */
export const useGetIncidents = () => {
  return useQuery({
    queryKey: monitoringQueryKeys.incidents(),
    queryFn: async (): Promise<IncidentListResponse> => {
      return { items: INCIDENTS_MOCK, total: INCIDENTS_MOCK.length };
    },
  });
};
